import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface RepackInput {
  variantId: string;
  batchNumber: string;
  qtyGm: number;
  costPerKg: number;
}

export interface RepackOutput {
  variantId: string;
  batchNumber: string;
  packs: number;
  packSizeGm: number;
}

export interface RepackCost {
  name: string;
  amount: number;
  allocateBy: 'BY_WEIGHT' | 'BY_PACKS';
}

export type RepackStatus = 'DRAFT' | 'POSTED' | 'CANCELLED';

export interface RepackPayload {
  jobNumber: string;
  date: string; // ISO string
  locationId: string;
  notes?: string;
  clientId: string;
  userId: string;
  status: RepackStatus;
  inputs: RepackInput[];
  outputs: RepackOutput[];
  costs: RepackCost[];
}

@Injectable({
  providedIn: 'root',
})
export class RepackService {
  constructor(private http: HttpClient) {}

  /**
   * Create a new repack job
   */
  createRepack(payload: any) {
    return this.http.post(`${environment.apiUrl}/repack`, payload);
  }

  /**
   * Get repacks with optional status filter
   */
  getRepacks() {
    return this.http.get(`${environment.apiUrl}/repack`);
  }

  /**
   * Get next repack job number
   */
  getNextRepackNumber(): Observable<{ nextNumber: string }> {
    return this.http.get<{ nextNumber: string }>(
      `${environment.apiUrl}/repack/next-number`
    );
  }

  /**
   * Get a repack by its ID
   */
  getRepackById(id: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/repack/${id}`);
  }

  /**
   * Update repack notes or status
   */
  updateRepack(id: string, payload: any): Observable<any> {
    return this.http.patch(`${environment.apiUrl}/repack/${id}`, payload);
  }

  /**
   * Post (finalize) a repack job
   */
  postRepack(id: string): Observable<any> {
    return this.http.post(`${environment.apiUrl}/repack/${id}/post`, {});
  }

  /**
   * Cancel a repack job
   */
  cancelRepack(id: string): Observable<any> {
    return this.http.post(`${environment.apiUrl}/repack/${id}/cancel`, {});
  }

  getChildProducts(id: string) {
    return this.http.get(`${environment.apiUrl}/products/bulk/${id}/children`);
  }

  saveBulkMapping(bulkId: string, payload: any) {
    return this.http.post(
      `${environment.apiUrl}/products/bulk/${bulkId}/mapping`,
      payload
    );
  }
}
